/**
 * Google SSO for the embed — mirrors apps/wunderguide-web/src/auth/index.ts.
 *
 * The /sso/google endpoint accepts an authed (guest) or unauthed client; with
 * a guest Bearer the backend converts the existing anonymous user in place
 * (same user_id — itinerary/chat sessions survive). On success we adopt the
 * returned tokens via setSessionFromExternal.
 *
 * NOTE: obtaining the Google credential itself happens in a POPUP
 * (public/google-sso.html) — Google Identity Services can't run inside a
 * cross-origin iframe, which is exactly what the embed is on partner pages.
 */
import { auth, httpClient, unauthClient } from '../client';

const AUTH_API = '/functions/v1/auth';

export async function signInWithGoogle(idToken: string) {
  const sessionInfo = await auth.getSessionInfo();
  const client = sessionInfo.token ? httpClient : unauthClient;
  const { data } = await client.post(`${AUTH_API}/sso/google`, {
    id_token: idToken,
  });
  const accessToken = data.access_token ?? data.accessToken;
  const refreshToken = data.refresh_token ?? data.refreshToken;
  const expiresAt = data.expires_at ?? data.expiresAt;
  const isNewUser = data.is_new_user ?? data.isNewUser ?? false;

  await auth.setSessionFromExternal({
    accessToken,
    refreshToken,
    expiresAt: Number(expiresAt),
  });
  return { isNewUser };
}
